export function bgColor(average) {
  if (average) {
    if (average < 1.75) {
      return 'rgba(248, 238, 110, .52)'
    } else if (average >= 1.75 && average <= 2.50) {
      return 'rgba(255, 199, 107, .52)'
    } else if (average >= 2.51 && average <= 3.50) {
      return 'rgba(186, 229, 138, .52)'
    } else {
      return 'rgba(120, 168, 225, .52)'
    }
  } else {
    return '#ffffff'
  }
}

export function DistrictDashboardHediColors(average) {
  if (average) {
    if (average < 1.75) {
      return '#AD6400'
    } else if (average >= 1.75 && average <= 2.50) {
      return '#9A8B70'
    } else if (average >= 2.51 && average <= 3.50) {
      return '#5B7999'
    } else {
      return '#093754'
    }
  } else {
    return '#ffffff'
  }
}